var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3H5V4H11V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5H5V6H11V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7H5V8H8V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15H4C3.73488 14.9997 3.4807 14.8942 3.29323 14.7068C3.10576 14.5193 3.0003 14.2651 3 14V2C3.0003 1.73488 3.10576 1.4807 3.29323 1.29323C3.4807 1.10576 3.73488 1.0003 4 1H12C12.2651 1.0003 12.5193 1.10576 12.7068 1.29323C12.8942 1.4807 12.9997 1.73488 13 2V14C12.9997 14.2651 12.8942 14.5193 12.7068 14.7068C12.5193 14.8942 12.2651 14.9997 12 15ZM4 2V14H12V2H4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentFile);
export default __webpack_public_path__ + "static/media/ic-document-file.a6466ff3fab38f6339b219766f856502.svg";
export { ForwardRef as ReactComponent };